<template>
  <div class="content background1">
    <div class="tableBox11">
      <div class="tableMes">
        <div class="table" style="padding: 0">
          <div class="treeMes" v-if="getTreeMes=='1'">
            <p class="title">{{$t('label_419')}}</p>
            <div class="chooseBox spaceBetween">
              <div class="selectBox">
                <div>
                  <div class="selectChoose">
                    <div class="selectText" style="width: 70px;">
                      <p>{{$t('label_383')}}</p>
                    </div>
                    <el-select v-model="Warehouseid" :placeholder="$t('input_65')"
                               @change="updateTable">
                      <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div>
                  <div class="selectChoose">
                    <div class="selectText" style="width: 70px;">
                      <p>{{$t('label_422')}}</p>
                    </div>
                    <div class="select">
                      <el-input v-model="taskName" clearable></el-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="buttonBox">
                <div>
                  <div class="chooseButton sendButton" @click="submitlist"><i class="el-icon-document-checked"></i>{{$t('btn_39')}}</div>
                </div>
              </div>
            </div>
            <div class="spotMes2Box">
              <div class="tableMin" style="height: calc(100% - 700px); max-height:calc(100% - 150px);">
                <!--table start-->
                <el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime" highlight-current-row
                          @current-change="handleCurrentChangeTree" border style="width: 100%;" :max-height="tableHeight"
                          :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                  <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
                  </el-table-column>
                  <el-table-column
                    :label="$t('label_331')"
                    align="left"
                    prop="typeName"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('label_124')"
                    align="left"
                    prop="code"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    :label="$t('label_664')"
                    align="left"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="maker"
                    :label="$t('label_672')"
                    align="left"
                  >
                    <template slot-scope="scope">
                      <popMesBox :popMes="scope.row.maker" :hoverMes="scope.row.maker" :popWidth="200"></popMesBox>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="saler"
                    :label="$t('label_235')"
                    align="left"
                  >
                    <template slot-scope="scope">
                      <popMesBox :popMes="scope.row.saler" :hoverMes="scope.row.saler" :popWidth="200"></popMesBox>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="model"
                    :label="$t('label_666')"
                    align="left"
                  >
                  </el-table-column>
                  <el-table-column :label="$t('label_327')" align="left" prop="warehouseName">
                  </el-table-column>
                  <el-table-column
                    prop="remark"
                    :label="$t('label_252')"
                    align="left"
                  >
                    <template slot-scope="scope">
                      <popMesBox :popMes="scope.row.remark" :hoverMes="scope.row.remark" :popWidth="200"></popMesBox>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="recordTime"
                    :label="$t('label_315')"
                    align="left"
                    width="200"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="stockNum"
                    :label="$t('label_500')"
                    align="left"
                  >
                  </el-table-column>
                  <el-table-column prop="" label="" align="left">
                    <template slot-scope="scope">
                      <i class="el-icon-delete" style="font-size: 30px;color: red;" @click="dele(scope.$index)"></i>
                    </template>
                  </el-table-column>
                </el-table>
                <!--table end  加号按钮-->
                <i class="el-icon-circle-plus-outline poin" style="font-size: 30px;margin-top:20px;"
                   @click="deviceCheckItemInfoEdit('1')"></i>
                <div style="position: absolute;bottom: 30px;left: 30%">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--		<exportMes :exportTitle="exportTitle" :exportData="tableDataTreeTimeExport" :exportList="exportList" style="width: 100%;height: 100%"-->
    <!--		 ref="exportBox"></exportMes>-->
    <!--弹窗start-->
    <el-dialog :title="deviceParamTitle" :visible.sync="dialogDeviceSpot" append-to-body :close-on-click-modal='false'
               width="70%" top="2%" :before-close="handleClose" custom-class="dialogBox">
      <div class="dialogBoxMes" style="padding:0 20px;">
        <div class="dialogMes">
          <div class="dialogMes">
            <p style="width: 140px">{{$t('label_664')}}</p>
            <div class="mesInput">
              <el-input v-model="tableDataEdit.name" clearable></el-input>
            </div>
          </div>
          <div class="dialogMes" style="margin-left: 30px">
            <p style="width: 140px">{{$t('label_331')}}</p>
            <div class="mesInput">
              <el-select v-model="tableDataEdit.type" filterable :placeholder="$t('input_65')">
                <el-option
                  v-for="item in checkList"
                  :key="item.id"
                  :label="item.val"
                  :value="item.key">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="dialogMes" style="margin-left: 30px">
            <p style="width: 70px">{{$t('label_327')}}</p>
            <div class="mesInput">
              <el-select v-model="tableDataEdit.warehouseId" disabled :placeholder="$t('input_65')"
                         @change="updateTable">
                <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="dialogMes">
          <div class="dialogMes">
            <p>{{$t('label_666')}}</p>
            <div class="mesInput">
              <el-input v-model="tableDataEdit.model" clearable></el-input>
            </div>
          </div>
          <div class="dialogMes" style="margin-left: 30px">
            <p>{{$t('label_672')}}</p>
            <div class="mesInput">
              <el-input v-model="tableDataEdit.maker" clearable></el-input>
            </div>
          </div>
        </div>
        <div class="buttonBox" style="position:absolute;right: 10px;top: 145px;">
          <div class="chooseButton sendButton" style="width: 90px" @click="deviceCheckItemInfoEdit('1')"><i
            class="el-icon-search"></i>{{$t('btn_2')}}
          </div>
        </div>
      </div>
      <div class="buttonBox">
        <div class="chooseButton searchButton" style="width: 110px;margin-left: 10px;" @click="addtable">{{$t('btn_53')}}</div>
      </div>
      <el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDatadialog" highlight-current-row
                @current-change="handleCurrentChangeTree" border height="530" style="width: 100%;margin: 10px;overflow: auto;"
                :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}" @selection-change="handleChange">
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
        </el-table-column>
        <el-table-column prop="type" :label="$t('label_331')" align="center">
          <template slot-scope="scope">
            {{checkText(scope.row.type)}}
          </template>
        </el-table-column>
        <el-table-column prop="code" :label="$t('label_124')" align="center">
        </el-table-column>
        <el-table-column prop="name" :label="$t('label_664')" align="center">
        </el-table-column>
        <el-table-column prop="maker" :label="$t('label_672')" align="center">
          <template slot-scope="scope">
            <popMesBox :popMes="scope.row.maker" :hoverMes="scope.row.maker" :popWidth="200"></popMesBox>
          </template>
        </el-table-column>
        <el-table-column prop="saler" :label="$t('label_235')" align="center">
          <template slot-scope="scope">
            <popMesBox :popMes="scope.row.saler" :hoverMes="scope.row.saler" :popWidth="200"></popMesBox>
          </template>
        </el-table-column>
        <el-table-column prop="model" :label="$t('label_666')" align="center">
        </el-table-column>
        <el-table-column prop="warehouseName" :label="$t('label_327')" align="center">
        </el-table-column>
        <el-table-column prop="remark" :label="$t('label_252')" align="center">
          <template slot-scope="scope">
            <popMesBox :popMes="scope.row.remark" :hoverMes="scope.row.remark" :popWidth="200"></popMesBox>
          </template>
        </el-table-column>
        <el-table-column prop="recordTime" :label="$t('label_315')"  width="200" align="center">
        </el-table-column>
        <el-table-column prop="stockNum" :label="$t('label_500')" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>
    <!--弹窗end-->
  </div>
</template>

<script>
import "@/assets/css/map/map.css"
import "@/assets/css/common/spot.css"
import Page from "@/components/common/page";
import utils from '@/utils/utils'
import calendar from "@/components/list/calendar/calendar";
import file from "@/assets/js/file/file.js";
import exportMes from "@/components/list/export/export";
import popMesBox from "@/components/list/popover/pop";
export default {
  name: 'inventoryTask',
  components: {
    Page,
    calendar,
    exportMes,
    popMesBox,
  },
  data() {
    return {
      tableHeight:600,
      taskName:'', // 任务名称
      timeText: "",  // 实时当前时间
      dateTime:'',   //  非实时当前时间
      tableDatadialog: [], // list 数组
      dialogDeviceSpot: false, // 默认弹窗状态
      tableDataEdit: {
        changeState: 0,
        content: "",
        cycle: "",
        cycleType: '1',
        decimals: 0,
        defaultValue: "string",
        equipmentTypeId: '',
        fileId: '',
        inputType: '1',
        length: 0,
        method: '',
        name: "",
        needPhoto: 0,
        maker: '',
        needPhotoNum: 5,
        needVideo: 0,
        needVideoNum: 1,
        pid: 0,
        remark: "string",
        sort: 0,
        unit: "string",
        weekend: '0',
        month: this.$t('label_245'),
        monthD: '1',
        monthDMes: '1',
        warehouseId: 1,
      },
      input2: '', //备件编号
      input3: '', // 入库数量
      name4: '',  // 手写出库数量
      pageNum: 1,
      select: 0,
      pageSize: 10,
      pageCount: 0,
      Readytime: '',
      height: 620,
      MenuRoleList: [],
      exportTitle: this.$t('label_396'),
      options: [],
      name: '', // 下拉选默认项
      tableDataTreeInfo: {},
      factoryDialogTitle: this.$t('btn_14'),
      getTreeMes: '1',
      dialogFactory: false,
      searchDataList: {
        dateTime:''
      },
      tableDataTreeTimeExport: [],
      tableDataTree: [],
      factoryTypeList: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      delelist: [], // 弹框list
      checkList: '', // 下拉选数据
      deviceParamTitle: '', // 弹窗title
      tableDataTreeTime: [], // 页面list
      Warehouseid: '',
      ckid: '',
      equipmentPartsInventoryRecords:[], // 添加数据的数组
      jobObj:''
    }
  },
  methods: {
    updateTable(val) {
      this.tableDataEdit.warehouseId = val
      let obj={}
      obj = this.options.find((item) => { // 这里的provincelist就是上面省的数据
        return item.id === val // 筛选出匹配数据，这里的id是接口数据中的每一项的id
      })
      this.jobObj=obj.name
      this.getNowTimes()
    },
    // 删除按钮
    dele(e) {
      this.tableDataTreeTime.splice(e,1)
    },
    // list 数据
    deviceCheckItemInfoEdit(title) {
      file.getEquipmentPartsall(this.tableDataEdit).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.tableDatadialog = data.data;
          this.dialogDeviceSpot = true;
          this.deviceParamTitle = this.$t('label_425');
        } else {
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    // 下拉选
    getCheckList() {
      file.getByDictIdALL({dictId: 3, languageType: sessionStorage.getItem("languageType")}).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.checkList = data.data;
          this.checkList.unshift({val: this.$t('label_272'),key:''})
        }
      }).catch((response) => {
        console.log(response)
      })
      // file.getPartsList().then((response) => {
      //   const data = response.data;
      //   if (data.code == "1") {
      //     this.checkList = data.data;
      //     this.checkList.unshift({val: this.$t('label_272'),key:''})
      //   }
      // }).catch((response) => {
      //   console.log(response)
      // })
    },
    // 仓库下拉选
    getWarehousedown() {
      file.getWarehousedown().then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.options = data.data;
          this.Warehouseid = this.options[0].id
          this.tableDataEdit.warehouseId = this.options[0].id
          this.getNowTimes()
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    // 过滤
    checkText(type) {
      var data = this.checkList.filter(function(item) {
        return item.key == type;
      });
      if (data != '') {
        return data[0].val
      }
    },
    // 单选
    handleChange(selection) {
      this.delelist = []
      this.delelist = selection
    },
    //  点击添加按钮
    addtable() {
      if (this.delelist.length == 0) {
        utils.messageAlert(this.$t('msg_4'), this.$t('label_358'), this.$t('label_100'));
      } else {
        this.tableDataTreeTime = []
        this.tableDataTreeTime = this.delelist
        this.dialogDeviceSpot = false;
      }
    },
    // 获取当前时间
    getTimeText() {
      let that = this;
      utils.timing(function() {
        that.timeText = utils.getNowFormatDate();
      }, 1000, 'timing');
    },
    // 点击提交按钮
    submitlist() {
      if (this.tableDataTreeTime.length > 0) {   // 判断一下 数组不为空
        if(!this.taskName || this.taskName=='' || this.taskName==undefined){
          this.$message({
            message: this.$t('input_43'),
            type: 'warning'
          });
        } else{
          this.tableDataTreeTime.forEach(item=>{
            let  param = {
              warehouseId:item.warehouseId,
              stockNum:item.stockNum,
              partsId:item.id,
              batchNum:item.batchNum
            }
            this.equipmentPartsInventoryRecords.push(param)    // 将需要的数据放到数组
          })
          file.getinventorytask({equipmentPartsInventoryRecords:this.equipmentPartsInventoryRecords,name:this.taskName,warehouseId: this.tableDataEdit.warehouseId}).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.tableDataTreeTime = []
              this.equipmentPartsInventoryRecords = []
              this.$message({
                message: $t('msg_23'),
                type: 'success'
              });
            }
          }).catch((response) => {
            console.log(response)
          })
        }

      } else {
        this.$message({
          message: this.$t('msg_3'),
          type: 'warning'
        });
      }
    },
    // 获取当前时间
    getNowTimes: function () {
      let dateTime
      let yy = new Date().getFullYear()
      let mm = new Date().getMonth()+1 < 10 ? '0' + (new Date().getMonth() +1): new Date().getMonth()+1
      let dd = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate()
      let hh = new Date().getHours()< 10 ? '0' + new Date().getHours() : new Date().getHours()
      let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
      let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
      this.taskName =  this.jobObj?this.jobObj+ '  ' + yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss
        :
        this.options[0].name + '  ' + yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss
      return dateTime
    },
    getIndex(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    exportClick() {
      this.$refs.exportBox.setExportExcel();
    },
    selectProp: function(index) {
      console.log(index)
      this.select = index
    },
    // 关闭弹窗
    handleClose() {
      this.dialogDeviceSpot = false;
    },
    handleCurrentChangeTree(info) {
      this.tableDataTreeInfo = info;
    },
    handleCurrentChangeTreeTime(info) {},
    search() {
      let param = {
        pageNum: 1,
        pageSize: this.pageSize
      }
    },
  },
  created() {
    this.getCheckList(); // 下拉选数据
    this.getWarehousedown()  // 获取仓库下拉
  }
}
</script>

<style scoped>
.el-input{
   width: 200px;
}
.ipt .el-input{
  border: 2px solid #49CDA8 !important;
  border-radius: 10%;
}
.sele_ipt.el-select {
  width:100px;
  border: 2px solid #49CDA8 !important;
  border-radius: 10%;
}
.input_wid .el-input{
  width: 50%;
  border: 2px solid #49CDA8 !important;
  border-radius: 10%;
}

.poin {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/part/inventoryTask.vue